import * as React from 'react';

export default React.createContext({
  isStandalone: true,
  editModeEnabled: false,
  onClickArea: (id: string) => {
    //
  },
});
